import * as React from "react";

const SvgRainThunder = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainThunder_svg__a">
        <path d="m615.362 691.713-5.267-9.122c-.826-1.43-.154-2.5 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.047.969 1.837-.68 1.752l-6.61-.338c-1.648-.085-2.322 1.016-1.496 2.444l2.909 5.04c.825 1.429.15 2.599-1.5 2.601l-3.611.004c-1.65.001-3.675-1.168-4.5-2.596" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainThunder_svg__b">
        <path d="M0 943.388h1828.656V0H0Z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainThunder_svg__c">
        <path d="m619.041 707.141-.159.003a8.288 8.288 0 0 1 0-16.575h20.6a6.696 6.696 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.124 9.493-10.622 9.493-4.342 0-8.077-2.591-9.751-6.31" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainThunder_svg__d">
        <path d="m589.844 682.311-6.499-11.257a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.733l6.499 11.256a2 2 0 0 1-.732 2.732 2 2 0 0 1-2.732-.732" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainThunder_svg__e">
        <path d="m600.478 682.311-6.499-11.257a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.733l6.499 11.256a2 2 0 0 1-.732 2.732 2 2 0 0 1-2.732-.732" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#RainThunder_svg__a)"
      style={{
        fill: "#fec524",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -768.96 977.98)"
    >
      <g
        style={{
          fill: "#fec524",
          fillOpacity: 1,
        }}
      >
        <path
          d="m615.362 691.713-5.267-9.122c-.826-1.43-.154-2.5 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.047.969 1.837-.68 1.752l-6.61-.338c-1.648-.085-2.322 1.016-1.496 2.444l2.909 5.04c.825 1.429.15 2.599-1.5 2.601l-3.611.004c-1.65.001-3.675-1.168-4.5-2.596"
          style={{
            fill: "#fec524",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#RainThunder_svg__b)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -768.96 977.98)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M0 0c5.89 0 10.664 4.774 10.664 10.664 0 5.889-4.774 10.664-10.664 10.664-.037 0-.072-.006-.109-.006-.949 8.504-8.158 15.116-16.915 15.116-6.915 0-12.864-4.125-15.528-10.048-.084.002-.168.006-.252.006-7.29 0-13.199-5.909-13.199-13.198C-46.003 5.909-40.094 0-32.804 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          transform="translate(625.264 690.57)"
        />
      </g>
    </g>
    <g
      clipPath="url(#RainThunder_svg__c)"
      style={{
        fill: "#d3e9f8",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -768.96 977.98)"
    >
      <g
        style={{
          fill: "#d3e9f8",
          fillOpacity: 1,
        }}
      >
        <path
          d="m619.041 707.141-.159.003a8.288 8.288 0 0 1 0-16.575h20.6a6.696 6.696 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.124 9.493-10.622 9.493-4.342 0-8.077-2.591-9.751-6.31"
          style={{
            fill: "#d3e9f8",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#RainThunder_svg__d)"
      style={{
        fill: "#00b2f0",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -768.96 977.98)"
    >
      <g
        style={{
          fill: "#00b2f0",
          fillOpacity: 1,
        }}
      >
        <path
          d="m589.844 682.311-6.499-11.257a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.733l6.499 11.256a2 2 0 0 1-.732 2.732 2 2 0 0 1-2.732-.732"
          style={{
            fill: "#00b2f0",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#RainThunder_svg__e)"
      style={{
        fill: "#00b2f0",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -768.96 977.98)"
    >
      <g
        style={{
          fill: "#00b2f0",
          fillOpacity: 1,
        }}
      >
        <path
          d="m600.478 682.311-6.499-11.257a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.733l6.499 11.256a2 2 0 0 1-.732 2.732 2 2 0 0 1-2.732-.732"
          style={{
            fill: "#00b2f0",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        stroke: "none",
        strokeWidth: 0.882081,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 -864.084 1257.85)"
      d="M648.063-943.388h72v72h-72z"
    />
  </svg>
);

export default SvgRainThunder;
